import React, {useState, useEffect, useContext} from 'react';

import {buyNowContext} from "../BuyNow";
import CheckoutHeader from "./CheckoutHeader";
import PaymentStage from "../payment/PaymentStage";
import ShippingStage from "../shipping/ShippingStage";
import ReviewStage from "../order_review/ReviewStage";
import OrderSummary from "../order_summary/OrderSummary";

import CountriesPropTypes from "../../prop-types/CountriesPropTypes";

const Checkout = ({countries}) => {
  const { PURCHASE_STAGES, purchaseStage } = useContext(buyNowContext);
  const [showOrderSummary, setShowOrderSummary] = useState(false);

  return (
    <React.Fragment>
      <CheckoutHeader
        showOrderSummary={showOrderSummary}
        setShowOrderSummary={setShowOrderSummary}
      />
      <div className={"container-fluid mt-4 pb-3 mb-3"}>
        <div className="row mt-lg-3 pt-2 pt-lg-5">
          {
            purchaseStage === PURCHASE_STAGES.SHIPPING && <ShippingStage countries={countries}/>
          }
          {
            purchaseStage === PURCHASE_STAGES.PAYMENT && <PaymentStage countries={countries}/>
          }
          {
            purchaseStage === PURCHASE_STAGES.REVIEW && <ReviewStage />
          }
          <OrderSummary
            showInMobileOnly={purchaseStage === PURCHASE_STAGES.REVIEW}
            showOrderSummary={showOrderSummary}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

Checkout.propTypes = {
  countries: CountriesPropTypes.isRequired
};

export default (props) => <Checkout {...props} />;